/**
 * Formats API error payloads into a human-readable string.
 * Handles string messages, field validation maps, and nested structures.
 */
export function formatApiErrorMessage(message: unknown): string {
  if (message == null || message === "") {
    return "Request failed";
  }

  if (typeof message === "string") {
    return message;
  }

  if (Array.isArray(message)) {
    return message.map((item) => formatApiErrorMessage(item)).join(" ");
  }

  if (typeof message === "object") {
    const parts: string[] = [];
    for (const value of Object.values(message as Record<string, unknown>)) {
      const formatted = formatApiErrorMessage(value);
      if (formatted && formatted !== "Request failed") {
        parts.push(formatted);
      }
    }
    return parts.length > 0 ? parts.join(" ") : "Request failed";
  }

  return String(message);
}

/** Extract a display message from a caught error (e.g. React Query mutation). */
export function getErrorMessage(error: unknown, fallback = "Request failed"): string {
  if (error instanceof Error && error.message) {
    return formatApiErrorMessage(error.message);
  }
  return formatApiErrorMessage(error) || fallback;
}
